import React, { useState, useEffect } from 'react';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import styles from './SessionFormation.module.sass';
import Dropdown from '../../../../components/Dropdown';
import { showError } from '../../../../services/toast.service';

const SessionFormation = ({ sessionData, onInputChange }) => {

    // Options pour le type de session
    const sessionTypeOptions = [
        { value: 'Présentiel', label: 'Présentiel' },
        { value: 'Distanciel', label: 'Distanciel' },
        { value: 'Hybride', label: 'Hybride' }
    ];

    // Fonction pour formater la date au format PocketBase (YYYY-MM-DD HH:MM:SS)
    // On stocke la date telle quelle sans conversion timezone
    const formatDateForPocketBase = (dateString) => {
        if (!dateString) return '';
        
        // Simplement reformater de 'YYYY-MM-DDTHH:MM' vers 'YYYY-MM-DD HH:MM:SS'
        const [datePart, timePart] = dateString.split('T');
        return `${datePart} ${timePart}:00`;
    };

    // Gérer les changements de date avec formatage (version simplifiée)
    const handleDateChange = (field, value) => {
        const formattedDate = formatDateForPocketBase(value);

        if (field === 'start_date') {
            onInputChange(field, formattedDate);
            
            // Suggestion automatique seulement si pas de date de fin définie
            if (!sessionData.end_date) {
                const [datePart, timePart] = value.split('T');
                const [hours, minutes] = timePart.split(':');

                // Ajouter 1 heure simplement
                let newHours = parseInt(hours) + 1;
                let newDate = datePart;
                
                // Gérer le passage à minuit
                if (newHours >= 24) {
                    newHours = newHours - 24;
                    const [year, month, day] = datePart.split('-');
                    const nextDay = String(parseInt(day) + 1).padStart(2, '0');
                    newDate = `${year}-${month}-${nextDay}`;
                }

                const endDateValue = `${newDate}T${String(newHours).padStart(2, '0')}:${minutes}`;
                onInputChange('end_date', formatDateForPocketBase(endDateValue));
            }
        } else {
            onInputChange(field, formattedDate);
        }
    };

    // Gérer les changements de champs simples
    const handleInputChange = (field, value) => {
        // Si c'est le dropdown session_type, extraire la valeur string
        if (field === 'session_type' && typeof value === 'object' && value !== null) {
            onInputChange(field, value.value);
        } else {
            onInputChange(field, value);
        }
    };


    return (
        <Card
            className={styles.card}
            title="Informations de la session"
            classTitle="title-green"
        >

            <div className={styles.row}>
                <div className={styles.col}>
                    <TextInput
                        className={styles.field}
                        label="Titre de la session"
                        name="title"
                        type="text"
                        placeholder="Entrez le titre de la session"
                        value={sessionData.title || ''}
                        onChange={(e) => onInputChange('title', e.target.value)}
                        required
                    />
                </div>
            </div>

            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Date de début"
                    name="start_date"
                    type="datetime-local"
                    min={new Date().toISOString().slice(0, 10) + 'T00:00'}
                    value={sessionData.start_date ? sessionData.start_date.replace(' ', 'T').slice(0, 16) : ''}
                    onChange={(e) => handleDateChange('start_date', e.target.value)}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Date de fin"
                    name="end_date"
                    type="datetime-local"
                    min={sessionData.start_date ? sessionData.start_date.replace(' ', 'T').slice(0, 16) : ''}
                    value={sessionData.end_date ? sessionData.end_date.replace(' ', 'T').slice(0, 16) : ''}
                    onChange={(e) => handleDateChange('end_date', e.target.value)}
                    required
                />
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Type de session"
                        name="session_type"
                        options={sessionTypeOptions}
                        value={sessionTypeOptions.find(option => option.value === sessionData.session_type) || null}
                        setValue={(value) => handleInputChange('session_type', value)}
                        required
                    />
                </div>

                {sessionData.session_type === 'Présentiel' && (
                    <TextInput
                        className={styles.field}
                        label="Salle de cours"
                        name="room"
                        type="text"
                        placeholder="Numéro ou nom de la salle"
                        value={sessionData.room || ''}
                        onChange={(e) => handleInputChange('room', e.target.value)}
                        required={sessionData.session_type === 'Présentiel'}
                    />
                )}

                {sessionData.session_type === 'Distanciel' && (
                    <TextInput
                        className={styles.field}
                        label="Lien de la visio"
                        name="room_link"
                        type="text"
                        placeholder="Lien de la visio"
                        value={sessionData.room_link}
                        onChange={(e) => handleInputChange('room_link', e.target.value)}
                        required
                    />
                )}


            </div>
        </Card>
    );
};

export default SessionFormation;